import { useIsSunriseTheme } from '@change-corgi/design-system-legacy/theme';

import type { DecisionMaker } from 'src/app/pages/petitionGamma/details/shared/types';

import type { AllDmResponses } from '../../hooks/useDecisionMakerCards';

import { DecisionMakerCard } from './components/DecisionMakerCard';
import { SunriseDecisionMakerCard } from './components/SunriseDecisionMakerCard';

type DecisionMakerCardContainerProps = {
	decisionMaker: DecisionMaker;
	allDmResponses: AllDmResponses;
};

export function DecisionMakerCardContainer({
	decisionMaker,
	allDmResponses,
}: DecisionMakerCardContainerProps): JSX.Element {
	const isSunriseThemeEnabled = useIsSunriseTheme();

	return isSunriseThemeEnabled ? (
		<SunriseDecisionMakerCard decisionMaker={decisionMaker} allDmResponses={allDmResponses} />
	) : (
		<DecisionMakerCard decisionMaker={decisionMaker} allDmResponses={allDmResponses} />
	);
}
